module.exports = __webpack_public_path__ + "static/media/logo.41f74321.svg";